<div class="container">
    <div class="editorItem">
        <div class="label">Account</div>
        @if (selectedAccount && isReadOnly && allowToNavigate) {
            <app-internal-navigator
                [path]="routeToSingle"
                [label]="selectedAccount.name"
                [isActive]="selectedAccount.isActive"
            ></app-internal-navigator>
        } @else {
            <div class="inputContainer">
                <app-type-ahead-accounts
                    [isReadOnly]="isReadOnly"
                    [displaySelected]="displaySelectedAccount"
                    [selectedAccount]="selectedAccount"
                    (selectedAccountChange)="onSelectedAccount($event)"
                    [error]="!isValid"
                    [isActive]="true"
                    [path]="routeToSingle"
                >
                </app-type-ahead-accounts>
                <app-validation-error-message
                    [show]="!isValid"
                    [errors]="validationErrors"
                ></app-validation-error-message>
            </div>
        }
    </div>
</div>
